export const PORTAL_ADMIN_ALL = "portal_admin:all";

export type AdminSection = "virtualCounter" | "pages" | "access";

export interface AdminNavigationItem {
  key: string;
  section: AdminSection;
  icon: string;
  path: string;
  activity: string;
}

export const ADMIN_SECTIONS: AdminSection[] = ["virtualCounter", "pages", "access"];

export const ADMIN_NAVIGATION: AdminNavigationItem[] = [
  {
    key: "ticketWindows",
    section: "virtualCounter",
    icon: "support_agent",
    path: "/admin/salas_atendimento",
    activity: "portal_admin:ticket_windows",
  },
  {
    key: "attendants",
    section: "virtualCounter",
    icon: "manage_accounts",
    path: "/admin/atendentes",
    activity: "portal_admin:attendants",
  },
  {
    key: "transparency",
    section: "pages",
    icon: "table_eye",
    path: "/admin/transparencia",
    activity: "portal_admin:transparency",
  },
  {
    key: "notices",
    section: "pages",
    icon: "campaign",
    path: "/admin/avisos",
    activity: "portal_admin:notices",
  },
  {
    key: "users",
    section: "access",
    icon: "group",
    path: "/admin/usuarios",
    activity: PORTAL_ADMIN_ALL,
  },
];

const PORTAL_ADMIN_ACTIVITIES = [
  PORTAL_ADMIN_ALL,
  "portal_admin:transparency",
  "portal_admin:who_is_who",
  "portal_admin:contacts",
  "portal_admin:carousel",
  "portal_admin:ticket_windows",
  "portal_admin:attendants",
  "portal_admin:users",
  "portal_admin:notices",
];

export function can(activities: string[], activity: string): boolean {
  if (activities.includes(activity)) {
    return true;
  }

  return PORTAL_ADMIN_ACTIVITIES.includes(activity) && activities.includes(PORTAL_ADMIN_ALL);
}

export function isActivePath(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}
